import moment from 'moment';

export const subDaysFromDate = (
  date: Date | string | undefined,
  day: number
) => {
  if (!date) return;
  return moment(date).subtract(day || 1, 'days').toISOString();
};
